import React from 'react';

interface Associate {
  Id: Number;
  Icon: String;
  fullName: Function;
  mRawData: Object;
  [key: string]: any;
}

interface PartnerBookTalkHeadProps {
  associate: Associate;
  content;
  currentUser;
  talkNow: Function;
  bookNow: Function;
  chatNow: Function;
  availableAssociates;
  viewUser: Function;
  getImageSrc: Function;
}

const PartnerBookTalkHead: React.FC<PartnerBookTalkHeadProps> = ({
  associate,
  content,
  currentUser,
  talkNow,
  bookNow,
  chatNow,
  availableAssociates,
  viewUser,
  getImageSrc,
}) => {
  const { Id, Icon, mRawData } = associate;

  // configs
  //@ts-ignore
  const bookTalkCompanywide = CrowdHub_App.CONFIG.PARTNER_BOOK_TALK_COMPANYWIDE; //@ts-ignore //@ts-ignore
  const partnerChatEnabled = CrowdHub_App.CONFIG.PARTNER_CHAT_BUTTON;

  // other vars
  //@ts-ignore
  const doNotDisturb = mRawData.level == CrowdHub_App.ROLE.USER_DONOTDISTURB; //@ts-ignore
  const adminDoNotDisturb = mRawData.level == CrowdHub_App.ROLE.ADMIN_DONOTDISTURB; //@ts-ignore //@ts-ignore
  const isMe = currentUser == Id;

  const isOnline = availableAssociates.find(availabelAssociate => {
    return associate.Id == availabelAssociate.Id;
  });

  const recipient = availableAssociates.find(associate => {
    return associate.Id == Id;
  });

  const fullName = associate.fullName();

  // get the string for their role at the company
  let aRole = '';

  // first go off of "ROLE" field in the crowdhub_content_to_users table
  //@ts-ignore
  if (mRawData.role != null && mRawData.role != '') {
    //@ts-ignore
    aRole = `${associate.Company} ${mRawData.role}`;

    // otherwise go off a title tag, or nothing if they have nothing
  } else {
    //@ts-ignore
    var aRoles = associate.PreferredTagsOfType(CrowdHub_App.TAGTYPE_TITLE);
    if (aRoles && aRoles.length) {
      //@ts-ignore
      aRole = `${associate.Company} ${aRoles[0].tag_name}`;
    } else {
      //@ts-ignore
      aRole = associate.Company;
    }
  }

  return (
    <div className={'partner_book_talk_head'}>
      <div
        className={'background_image_container ui_relative center_withmargins'}
        onClick={e => {
          viewUser(associate);
        }}
      >
        <div
          className={'background_image cover_absolute'}
          style={{
            backgroundImage: `url(${getImageSrc(Icon)})`,
          }}
        ></div>
      </div>
      <div className={'slide_title ui_textalign_center'}>{fullName}</div>
      <div className={'slide_subtitle ui_textalign_center'}>{aRole}</div>
      {!doNotDisturb &&
      !adminDoNotDisturb &&
      !bookTalkCompanywide &&
      !isMe &&
      App.INSTANCE?.CurrentUser?.IsLoggedIn() ? (
        <div className={'book_buttons_container'}>
          {isOnline && (
            <div
              onClick={() => {
                talkNow(recipient);
              }}
              className={'cssButton mini_button_outline booktalk_head_btn'}
            >
              {
                //@ts-ignore
                CrowdHub_App.LANG.BUTTON_TALKNOW
              }
            </div>
          )}
          <div
            onClick={() => {
              bookNow(associate, content);
            }}
            className={'cssButton mini_button_outline booktalk_head_btn'}
          >
            {
              //@ts-ignore
              CrowdHub_App.LANG.BUTTON_BOOKNOW
            }
          </div>
          {partnerChatEnabled && (
            <div
              onClick={() => {
                chatNow(associate);
              }}
              className={'cssButton mini_button_outline booktalk_head_btn'}
            >
              {
                //@ts-ignore
                CrowdHub_App.LANG.BUTTON_CHATNOW
              }
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
};
export default PartnerBookTalkHead;
